// Auto-generated version file
// This file should be updated whenever package.json version changes

export const APP_VERSION = '1.2.4';
export const BUILD_DATE = '2025-10-31';
